var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M14 0v32H4V0h10zm14 0v32H18V0h10z"}));
}

Pause.defaultProps = {"width":"32","height":"32","aria-label":"Pause","viewBox":"0 0 32 32"};

module.exports = Pause;

Pause.default = Pause;
